export default "__VITE_ASSET__da134fbb__"